/**
 * Editorial identity for Modern Nomad Living.
 *
 * The site uses an Organization-as-author model (Wirecutter / Economist style).
 * No individual authors, no Person schema, no fake LinkedIn URLs. E-E-A-T is
 * established through the Editorial Standards section on /about.
 */
export const EDITORIAL_TEAM = {
  name: 'Modern Nomad Living Editorial Team',
  shortName: 'The Editorial Team',
  initials: 'MN',
  bio: 'Researched and edited by the Modern Nomad Living team — writers, builders, and full-time nomads who have lived these systems first-hand. Every guide is verified against field experience or primary sources before publication.',
  expertise: ['Van life', 'Off-grid systems', 'Boat living', 'Camping logistics'],
  url: 'https://modernnomadliving.com/about#editorial-standards',
} as const;